interface SuggestionChipsProps {
  items: string[];
  onPick: (suggestion: string) => void;
  disabled?: boolean;
  /** Describes the group for screen readers, e.g. "Follow-up suggestions". */
  label: string;
}

/**
 * Clickable follow-ups.
 *
 * Every chip is asked as an ordinary question, so a chip can never do something a typed message
 * could not. The backend only ever offers chips grounded in a real tool (`backend/chat_suggestions`),
 * which is what stops the row becoming a menu of things the system cannot actually do.
 */
export function SuggestionChips({
  items,
  onPick,
  disabled = false,
  label,
}: SuggestionChipsProps): JSX.Element | null {
  if (items.length === 0) {
    return null;
  }
  return (
    <div className="chips" aria-label={label}>
      {items.map((item) => (
        <button
          key={item}
          type="button"
          className="chips__item"
          disabled={disabled}
          onClick={() => onPick(item)}
        >
          {item}
        </button>
      ))}
    </div>
  );
}
